export default url => url && url.replace(`${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_HOST_NAME}`, '')



// WEBPACK FOOTER //
// ./src/utils/getRelativeUrl.js